(function () {
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!canHover) return;

  var ZOOM_SCALE = 1.8;

  function activeImage(viewer) {
    var active = viewer.querySelector('.product__media-item.is-active img');
    return active || viewer.querySelector('.product__media-item img');
  }

  function setup(gallery) {
    if (gallery.dataset.wmZoomInit) return;
    var viewer = gallery.querySelector('slider-component[id^="GalleryViewer-"]');
    if (!viewer) return;
    gallery.dataset.wmZoomInit = 'true';

    viewer.addEventListener('mousemove', function (e) {
      var img = activeImage(viewer);
      if (!img) return;
      var rect = img.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      x = Math.max(0, Math.min(100, x));
      y = Math.max(0, Math.min(100, y));
      img.style.transformOrigin = x + '% ' + y + '%';
      img.style.transform = 'scale(' + ZOOM_SCALE + ')';
    });

    viewer.addEventListener('mouseleave', function () {
      var img = activeImage(viewer);
      if (!img) return;
      img.style.transform = '';
      img.style.transformOrigin = '';
    });
  }

  function init(root) {
    (root || document).querySelectorAll('media-gallery').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var g = e.target.querySelector('media-gallery');
    if (g) setup(g);
  });
})();
